module.exports = "//docs.gtimg.com/slide/img/slide/application/service/mobile-remote-control-dropdown/core/qrcode-mask/login-bg-applet-8c67de.png";